import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPopulateChallengeBody } from './populate-challenge-request';
import type { IPopulateChallengeResponse } from './populate-challenge-response';
import { populateChallengeResponseSchema } from './populate-challenge-response';

export async function populateChallengeApi(
  body: IPopulateChallengeBody,
): Promise<IValidatedResponse<IPopulateChallengeResponse>> {
  return postRequest<IPopulateChallengeResponse>({
    path: '/sys/challenges/populate',
    body,
    schema: populateChallengeResponseSchema,
    options: { timeout: 120_000 },
  });
}
